import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { noop } from 'lodash-es';
import TagEditor from './index';
import DropdownOption from '../dropdown/DropdownOption';
import DropdownOptionWrapper from '../dropdown/DropdownOptionWrapper';
const StyledDiv = styled.div `
  width: ${({ width }) => width};
  position: relative;
`;
const TagSelector = props => {
    const { isOpen, width = '300px', onTagChange, tags, options, onClickOutside, disabledTagsIndex = [], } = props;
    const wrapperRef = useRef(null);
    const [optionMarginTop, setOptionMarginTop] = useState('');
    useEffect(() => {
        if (wrapperRef.current) {
            setOptionMarginTop(`${wrapperRef.current.offsetHeight - 32}px`);
        }
    }, [tags]);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handler = (event) => {
                if (wrapperRef &&
                    wrapperRef.current &&
                    !wrapperRef.current.contains(event.target)) {
                    onClickOutside();
                }
            };
            window.addEventListener('mousedown', handler);
            return () => window.removeEventListener('mousedown', handler);
        }
        return noop;
    }, [onClickOutside]);
    const onClick = (option, index) => {
        if (disabledTagsIndex.includes(index)) {
            return;
        }
        if (!tags.includes(option.key)) {
            onTagChange([...tags, option.key]);
        }
        else {
            onTagChange(tags.filter(tag => tag !== option.key));
        }
    };
    const tagKeytoLabel = allTags => {
        return allTags.map(tag => {
            const targetOption = options.find(option => option.key === tag);
            if (targetOption) {
                return targetOption.label;
            }
            return '';
        });
    };
    const tagLabeltoKey = allTags => {
        return allTags.map(tag => {
            const targetOption = options.find(option => option.label === tag);
            if (targetOption) {
                return targetOption.key;
            }
            return '';
        });
    };
    return (React.createElement(StyledDiv, { ref: wrapperRef, width: width },
        React.createElement(TagEditor, Object.assign({}, props, { selectorMode: true, tags: tagKeytoLabel(tags), onTagChange: newTags => onTagChange(tagLabeltoKey(newTags)) })),
        React.createElement(DropdownOptionWrapper, { isOpen: isOpen, menuAlign: "center", width: width, optionMarginTop: optionMarginTop }, options.map((option, index) => (React.createElement(DropdownOption, { key: option.key, selected: tags.includes(option.key), disabled: option.disabled, onClick: () => onClick(option, index), label: option.label }))))));
};
export default TagSelector;
//# sourceMappingURL=TagSelector.js.map